import { useTranslation } from 'react-i18next';
import { cn } from '~/common/utils/styleUtil';
import { ArticleSlider } from '~/common/components/ArticleSlider';
import { useRecommendedArticles } from '~/features/catalog/routes/resources/RecommendedArticlesRoute.tsx';

export interface RecommendedProductsProps {
  className?: string;
  articleNumber: string;
  hwgId?: number;
  hagrCode?: number;
  agrCode?: number;
}

export function RecommendedProducts({ className, articleNumber, hwgId, hagrCode, agrCode }: Readonly<RecommendedProductsProps>) {
  const { t } = useTranslation();
  const { articles } = useRecommendedArticles(articleNumber, hwgId, hagrCode, agrCode);

  if (articles?.length === 0) {
    return null;
  }

  return (
    <div className={cn(className)}>
      <h2 className={'block text-xl font-bold mb-4'}>{t('Oft zusammen gekauft')}</h2>
      <ArticleSlider articles={articles} />
    </div>
  );
}
